import { render } from "./PublicBoard.vue?vue&type=template&id=57e79dab"
import script from "./PublicBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicBoard.vue?vue&type=script&setup=true&lang=js"

import "./PublicBoard.vue?vue&type=style&index=0&id=57e79dab&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/boards/PublicBoard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57e79dab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57e79dab', __exports__)) {
    api.reload('57e79dab', __exports__)
  }
  
  module.hot.accept("./PublicBoard.vue?vue&type=template&id=57e79dab", () => {
    api.rerender('57e79dab', render)
  })

}


export default __exports__